import { GAME_CATEGORIES, type GameCategory } from '$lib/category';

const SKIP_PRERENDER: ReadonlySet<GameCategory> = new Set(['favorites', 'recentlyplayed']);

export function entries() {
	return GAME_CATEGORIES.filter((c) => !SKIP_PRERENDER.has(c)).map((category) => ({ category }));
}

export const load = ({ params }: { params: { category: string } }) => {
	return {
		category: params.category as GameCategory
	};
};
